import React from 'react';
import { PsTable } from '../../../../shared/components/table/PsTable';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import RouterUtils from '../../../../shared/routing/RouterUtils';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import { PsRoutes } from '../../../../shared/routing/Routes';

export class WorkListTable extends React.Component {

    render() {
        const {
            data,
            error,
        } = this.props;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        if ( !data || data.length === 0 ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS')}</h3>
                </section>
            );
        }

        return (
            <PsTable
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_CODIGO')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_FECHA_INICIO')}</th>
                        <th>{I18nUtils.tr('TR_FECHA_FIN')}</th>
                    </tr>
                )}
            >
                {
                    data.map((cs) => {
                        const id = cs.id();
                        const route = RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL, { id });

                        return (
                            <tr key={id}>
                                <td>{cs.code()}</td>
                                <td><Link to={route}>{cs.name()}</Link></td>
                                <td>{cs.startDateString()}</td>
                                <td>{cs.endDateString()}</td>
                            </tr>
                        );
                    })
                }
            </PsTable>
        );
    }

}

WorkListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
};

WorkListTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/work/WorkListTable.jsx